import React from "react";

const FilterIcon = (props) => {
  return (
  <svg 
  {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.3334 2.5H1.66675L8.33341 10.3833V15.8333L11.6667 17.5V10.3833L18.3334 2.5Z" stroke="#157540" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

  );
};


export default FilterIcon;